import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';

const CharterPage: React.FC = () => {
  const charterArticles = [
    {
      id: 1,
      title: "인간의 사고 확장",
      content: "AI는 인간의 사고, 창의성, 문제 해결 능력을 증폭시키는 학습의 확장 도구이다. 교육은 학생이 AI를 활용해 독창적인 탐구 주제를 설정하고, 스스로 학습 목표와 경로를 주도적으로 설계·개선하도록 이끌어야 한다."
    },
    {
      id: 2,
      title: "협력적 지식 창작과 공유",
      content: "지식은 인간과 AI의 협력으로 창출되는 공동의 산물이다. 교육은 협력적 산물을 평가와 학습의 일부로 삼고, 이를 사회와 공유 가능한 자산으로 확장하여 윤리적 성찰을 포함한 공동 창작 과정을 훈련해야 한다."
    },
    {
      id: 3,
      title: "교실 혁신과 탐구적 실험",
      content: "교실은 인간과 AI의 상호작용을 실험하는 학습의 장이다. 교육은 새로운 시도를 장려하고 실패를 학습의 일부로 받아들이며, 실험을 통해 얻은 결과를 기록·분석하여 교실 혁신을 지속적으로 이어가야 한다."
    },
    {
      id: 4,
      title: "비판적 탐구와 창조적 전환",
      content: "AI에 대한 비판은 거부가 아니라 더 나은 협력의 전제이다. 교육은 학생이 AI의 답변을 분석하고 대안을 제시하도록 훈련하며, AI의 편향과 오류를 새로운 학습과 연구의 출발점으로 전환해야 한다."
    },
    {
      id: 5,
      title: "AI 문해력 향상",
      content: "AI를 이해하고 활용하며 비판하는 능력은 미래 교육의 핵심이다. 교육은 모든 학생이 AI 모델을 직접 다루고 평가할 수 있도록 커리큘럼을 설계하여, AI 문해력과 비판적 사고를 체계적으로 길러야 한다."
    },
    {
      id: 6,
      title: "데이터 윤리와 책임 있는 활용",
      content: "교육 데이터는 개인의 프라이버시를 보호하면서 동시에 창의적 자원으로 활용될 수 있다. 교육 학생 데이터 공유 및 활용 시 학생과 학부모의 동의 절차를 준수하며, 익명화·공유 과정에서 윤리적 기준을 확립하고 이를 교육 공동체 전반에 내재화해야 한다."
    },
    {
      id: 7,
      title: "초월적 창의성과 가치 창조",
      content: "교육의 목표는 단순한 기술 습득을 넘어 인간과 AI가 함께 새로운 가치를 창출하는 데 있다. 교육은 AI가 제시할 수 없는 질문을 탐구하고, 인문·예술·철학적 상상력을 결합해 초월적 창의성을 실현해야 한다."
    },
    {
      id: 8,
      title: "교육자의 역할 재정의",
      content: "AI가 지식 전달을 대체하는 시대에 교육자는 학생에게 의미와 가치를 더하는 해석자이자 설계자가 되어야 한다. 교육자는 AI 결과를 인간적 맥락 속에 재구성하고, 학생의 성찰과 탐구를 이끄는 안내자가 되어야 한다."
    },
    {
      id: 9,
      title: "AI 접근성과 교육 기회의 평등",
      content: "AI는 일부에게만 특권적으로 제공되는 도구가 아니라, 모든 학습자가 공평하게 누려야 할 교육 자원이다. 교육은 사회적·경제적 배경과 무관하게 AI 활용할 수 있는 기회를 보장하고, 교육 격차를 해소하고 학습의 평등을 실현해야 한다."
    }
  ];

  const practiceItems = [
    {
      article: 1,
      title: "인간의 사고 확장",
      practices: [
        "학생이 AI를 활용해 교재를 넘어 독창적인 탐구 주제를 설정하도록 지원한다.",
        "AI가 제안하는 개별 학습 경로를 시범적으로 도입하되, 학습 목표는 학생과의 협의를 통해 주도성을 보장한다."
      ]
    },
    {
      article: 2,
      title: "협력적 지식 창작과 공유",
      practices: [
        "과제와 프로젝트를 인간과 AI의 협력 산물로 간주하고, 협업 과정의 기여도와 창의성을 평가에 포함한다.",
        "수업 결과물을 익명화된 공공 자원으로 전환하여 교육 기관과 지역사회가 활용할 수 있도록 공유한다.",
        "AI 협력 과정에서 발생하는 윤리적 쟁점을 토론하고, 이를 교육 콘텐츠로 발전시킨다."
      ]
    },
    {
      article: 3,
      title: "교실 혁신과 탐구적 실험",
      practices: [
        "매 학기 최소 한 차례 이상 인간–AI 협력 수업을 기획하고 실행한다.",
        "수업의 실험 결과(성공과 실패 모두 포함)를 기록하고, 차기 수업 설계에 반영하여 개선한다."
      ]
    },
    {
      article: 4,
      title: "비판적 탐구와 창조적 전환",
      practices: [
        "학생이 AI의 답변을 비판적으로 검토하고 대안적 관점을 제시하도록 장려한다.",
        "AI의 오류나 편향을 새로운 학습 주제와 연구 과제로 전환한다.",
        "비판적 사고를 위한 가이드라인을 제공하고, 학생의 분석 역량을 체계적으로 훈련한다."
      ]
    },
    {
      article: 5,
      title: "AI 문해력 향상",
      practices: [
        "AI 활용, 비판을 주제로 정규 교과를 설계하고, 교육과정에 통합한다.",
        "학생이 간단한 AI 모델을 설계하거나 수정해보는 실습 기회를 제공한다.",
        "학생의 AI 활용 능력과 비판적 사고를 정기적으로 평가할 수 있는 기준을 마련한다."
      ]
    },
    {
      article: 6,
      title: "데이터 윤리와 책임 있는 활용",
      practices: [
        "학생 데이터를 익명화하고, 개인 식별 가능 정보를 배제한다.",
        "데이터 활용 전에 학생과 학부모에게 목적과 범위, 보존 기한을 명확히 알리고, 사전 동의를 받는다.",
        "데이터 수집, 저장, 분석, 공유 전 과정에서 윤리적 기준을 준수하고, 교육자와 학생 모두가 실천하도록 훈련한다."
      ]
    },
    {
      article: 7,
      title: "초월적 창의성과 가치 창조",
      practices: [
        "인문학, 예술, 철학적 상상력을 AI와 결합한 창작 과제를 개발한다.",
        "학생이 AI의 한계를 넘어서는 창의적 아이디어를 제안하도록 유도하고, 이를 평가와 보상 체계에 반영한다."
      ]
    },
    {
      article: 8,
      title: "교육자의 역할 재정의",
      practices: [
        "AI의 답변을 단순히 전달하는데 그치지 않고, 인간적 맥락, 윤리적 고려, 사회적 가치를 더해 해석한다.",
        "학생이 AI 협력 과정에서 새로운 의미를 발견하도록 토론과 프로젝트를 설계한다.",
        "교육자 스스로 AI 문해력과 윤리적 판단 능력을 지속적으로 개발하도록 연수 프로그램을 제공한다."
      ]
    },
    {
      article: 9,
      title: "AI 접근성과 교육 기회의 평등",
      practices: [
        "모든 학생이 AI 기반 학습 도구에 원활히 접근할 수 있도록 학교와 지역 차원의 지원 체계를 마련한다.",
        "디지털 격차로 인해 학습에서 소외되지 않도록, 취약 계층 학생을 위한 보완적 자원과 맞춤형 지원을 제공한다.",
        "AI 활용 교육이 특정 계층이나 집단에 집중되지 않도록, 교육 기회의 평등성을 정기적으로 점검하고 제도화한다."
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="h-16" />
      <Breadcrumb />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            인간-AI 협력 교육 헌장
          </h1>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            AI 시대의 교육이 기술의 단순한 도입을 넘어, 인간과 AI가 상호작용하며 배우고 창조하는 문명의 전환점임을 선언합니다.
          </p>
        </div>

        {/* 헌장의 맥락 */}
        <div className="bg-teal-50/60 border-l-4 border-teal-400 rounded-r-xl p-6 mb-14">
          <p className="text-gray-700 text-base leading-relaxed">
            <strong>헌장 제4조, "비판적 탐구와 창조적 전환"</strong>은 말합니다 —
            "AI에 대한 비판은 거부가 아니라 더 나은 협력의 전제이다."
            이 헌장은 AI를 맹목적으로 수용하거나 두려워하는 것이 아니라,
            충분히 이해하고 비판하며 협력하는 교육 생태계를 만들기 위한 약속입니다.
          </p>
          <Link
            to="/philosophy"
            className="inline-flex items-center mt-3 text-sm text-teal-600 hover:text-teal-800 font-medium"
          >
            CHAIR의 철학적 배경 읽기 →
          </Link>
        </div>

        {/* Charter Declaration */}
        <section className="mb-16">
          <div className="bg-white rounded-lg p-8 shadow-sm">
            <div className="prose max-w-none">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">헌장 선언</h2>
              <div className="bg-teal-50/60 rounded-lg p-6 mb-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  우리는 AI 시대의 교육이 기술의 단순한 도입을 넘어, 인간과 AI가 상호작용하며 배우고 창조하는 문명의 전환점임을 선언한다. 
                  AI는 도구를 넘어 동반자이자 협력적 탐구의 파트너임을 인식하며, AI 교육은 인간과 함께 탐구하며 성장하는 협력적 교육 생태계로 자리매김해야 한다. 
                  이 헌장은 인간과 AI가 협력하여 지식과 가치를 창출하고, 미래 교육을 향해 나아가는 우리의 약속이다.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Charter Articles */}
        <section className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">헌장 조항</h2>
            <p className="text-lg text-gray-600">
              인간-AI 협력 교육을 위한 9개 핵심 조항입니다.
            </p>
          </div>

          <div className="space-y-8">
            {charterArticles.map((article) => (
              <div key={article.id} className="bg-white rounded-lg p-8 shadow-sm">
                <div className="flex items-start mb-4">
                  <div className="bg-teal-50 w-12 h-12 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <span className="text-teal-600 font-bold text-lg">{article.id}</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      제{article.id}조. {article.title}
                    </h3>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {article.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Practice Guidelines */}
        <section className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">함께 만들어 가는 실천사항</h2>
            <p className="text-lg text-gray-600">
              각 조항에 대한 구체적인 실천 방안입니다.
            </p>
          </div>

          <div className="space-y-8">
            {practiceItems.map((item) => (
              <div key={item.article} className="bg-white rounded-lg p-8 shadow-sm">
                <h3 className="text-xl font-bold text-gray-900 mb-6">
                  제{item.article}조. {item.title}
                </h3>
                <div className="space-y-4">
                  {item.practices.map((practice, index) => (
                    <div key={index} className="flex items-start">
                      <div className="bg-green-100 w-8 h-8 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                        <span className="text-green-600 font-semibold text-sm">{index + 1}</span>
                      </div>
                      <p className="text-gray-700 leading-relaxed">
                        {practice}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center bg-teal-50/60 rounded-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            인간-AI 협력 교육의 미래를 함께 만들어가세요
          </h2>
          <p className="text-lg text-gray-600 mb-6">
            이 헌장은 우리 모두가 함께 실천해야 할 약속입니다. 인간과 AI가 협력하는 교육의 새로운 시대를 열어가겠습니다.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/about" 
              className="inline-flex items-center px-6 py-3 bg-teal-500 text-white font-medium rounded-lg hover:bg-teal-600 transition-colors"
            >
              센터 소개 보기
            </Link>
            <Link 
              to="/divisions" 
              className="inline-flex items-center px-6 py-3 bg-white text-teal-600 font-medium rounded-lg border border-teal-500 hover:bg-teal-50/60 transition-colors"
            >
              연구 분과 알아보기
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CharterPage;
